import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import store from "Store/index";
import { OrderingListViewModel, UpdateIsActiveOnOrderingListItemCommand, OrderingListItemViewModel, UpdateIsDeletedOnOrderingListItemCommand, UpdateIsAvailableOnOrderingListItemCommand } from 'Api/CoreApi';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import OrderingListMixin from 'Mixins/OrderingListMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { mixins } from 'vue-class-component';

@Component({
    template: "#ordering-list-item-template"
})
export default class OrderingListItemComponent extends mixins(BaseComponent,OrderingListUserMixin, OrderingListMixin) {
    @Prop()
    public productKey: string;
    
    public loaded: boolean = true;
    
    buildFromParentListId: string;
    buildListId: string;
    buildList: boolean = false;
    
    async created() {
        
        await store.dispatch.orderingList.loadFilter();
        await store.dispatch.orderingList.loadOrderingLists(false);
        
        const urlParams = new URLSearchParams(window.location.search);
        
        
        // const selectedListId = await store.state.auth.user.extraInfo.SelectedListId;
        let orderingListId = '';
        
        if(urlParams.has('orderinglistid')){
            //current index returned from DW
            orderingListId = urlParams.get('orderinglistid');
        }
        if(urlParams.has('buildorderinglistid'))
        {
            //build list (child list)
            this.buildListId = urlParams.get('buildorderinglistid');
            this.buildFromParentListId = orderingListId;
            //build the building list from return index products
            this.buildList = true;
        }
        
        if(this.isEmployee && !orderingListId)
        {            
            orderingListId = store.state.auth.user.extraInfo.SelectedListId;
        }
        
        
        if(this.buildList)
        {
            //extended- build list from parent but compare to build list id
            await store.dispatch.orderingList.loadOrderingListById({force: false, buildList: true, id: this.buildListId, scopeIsFromShop: !this.scopeIsOrderingList});
        }else if(orderingListId){
            //default - get list by orderinglist id in query
            await store.dispatch.orderingList.loadOrderingListById({force: false,buildList: false, id: orderingListId, scopeIsFromShop: !this.scopeIsOrderingList});
        }
        else{
            if(!this.isEmployee){
                //default - get current users list
                await store.dispatch.orderingList.loadMasterList(false);
            }
        }
        
        
        
        //TODO: clean up spagetti code -here
        // if(selectedListId)
        // {
        //     await store.dispatch.orderingList.loadOrderingListById(selectedListId);
        // }
        
    }
    
    async mounted(){
    }
    
    
    get itemIsActive(): boolean{
        var test= store.state.orderingList.detectChanges;
        return  this.item != null && this.item.isActive;
    }

    get itemIsDeleted(): boolean {
        var test = store.state.orderingList.detectChanges;
        return this.item != null && this.item.isDeleted;
    }
    
    get isActive(): boolean {
        //hack to trigger re-rendering of component
        if(!this.itemIsActive && this.buildList)
        {
            return false;
        }
        
        return this.itemIsActive;
    }

    

    get isDeleted(): boolean {
        //hack to trigger re-rendering of component
        console.log(this.itemIsDeleted);
        if (!this.itemIsDeleted && this.buildList) {
            return false;
        }

        return this.itemIsDeleted;
    }


    get showIsDeleted(): boolean {
        return this.list && this.isAdvancedAdmin;
    }

    get showIsAvailable(): boolean{
        return this.list && this.list.permissions.canAdditemFromParent;
    }
    
    get isAvailable(): boolean{
        //hack to trigger re-rendering of component
        if(!this.itemIsAvailable && this.buildList || (this.list && !this.list.permissions.canAdditemFromParent))
        {
            return false;
        }
        
        return this.itemIsAvailable;// || this.itemIsCustomerAgreement; return this.itemIsAvailable;// || this.itemIsCustomerAgreement;
    }
    
    get itemIsAvailable(): boolean{
        var test= store.state.orderingList.detectChanges;
        return this.item != null && this.item.isAvailable;
    }
    
    // get itemIsCustomerAgreement(): boolean{
    //     if(store.state.customerAgreement.list)
    //     {
    //         return store.state.customerAgreement.list.includes(this.productKey);
    //     }
    //     return false;
    // }
    
    get show() {
        if(this.item && this.item.isCustomerAgreement) {
            return true;
        }
        return this.item || this.buildList;
    }

    get showDelete() {
        if (this.item && this.item.isCustomerAgreement) {
            return true;
        }
        return this.item;
    }
    
    get item(): OrderingListItemViewModel
    {
        return this.list && this.list && this.list.items && this.list.items.find(x => x.productKey == this.productKey);
    }
    
    
    get list() : OrderingListViewModel{
        return store.state.orderingList.currentOrderingList;
    }
    
    async toggleDelete(event: any) {
        if (!this.item) {
            //wut?
        }

        //remove product
        await store.dispatch.orderingList.updateIsDeleted(new UpdateIsDeletedOnOrderingListItemCommand({
            orderingListId: this.item ? this.list.id : this.buildFromParentListId,
            productKey: this.productKey,
            isDeleted: !this.isDeleted
        }));

    }

    async toggleProductForAll(event: any){
        if(!this.item)
        {
            //wut?
        }
        
        //remove product
        await store.dispatch.orderingList.updateIsAvailable(new UpdateIsAvailableOnOrderingListItemCommand({
            orderingListId : this.item ? this.list.id : this.buildFromParentListId,
            productKey : this.productKey,
            isAvailable: !this.isAvailable
        }));
    }
    
    // async toggleProduct(event: any){
        
    //     if(!this.item)
    //     {
    //         alert('blblblb');
    //     }
        
    //     //remove product
    //     await store.dispatch.orderingList.updateIsActive(new UpdateIsActiveOnOrderingListItemCommand({
    //         orderingListId : this.item ? this.list.id : this.buildFromParentListId,
    //         productKey : this.productKey,
    //         isActive: !this.isActive
    //     }));
        
        
    // }
    
    
}

Vue.component('ordering-list-item', OrderingListItemComponent);
